import React, { Component } from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import Transition from 'react-transition-group/Transition';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import DownloadIcon from 'material-ui/svg-icons/file/file-download';
import CloseIcon from 'material-ui/svg-icons/navigation/close';
import {red500, red800} from 'material-ui/styles/colors';
import {connect} from 'react-redux';

import * as firebase from 'firebase';

const SHOW_WARNING = 'showWarning';
const CLOSE_WARNING = 'closeWarning';
const DELETE_IMAGE = 'deleteImage';

class PhotoScreen extends Component {

  transitionStyles = {
    entering: {opacity: 1, backgroundColor: 'rgba(0,0,0,0.5)'},
    entered: {opacity: 1, backgroundColor: 'rgba(0,0,0,0.5)'},
  }

  constructor(props){
    super(props)
    this.state={
      toolbarVisible: false,
      fullscreenVisible: false,
      warningModalVisible: false,
      imageUrl: ''
    }
  }

  componentWillMount(){
    this.showFullScreen(this.props);
  }

  componentWillReceiveProps(nextProps){
    this.showFullScreen(nextProps)
  }

  showFullScreen = (props) => {
    let visible = false
    let imageUrl = ''
    if (props.imageUrl) {
      visible = true
      imageUrl = props.imageUrl
    }
    this.setState({
      fullscreenVisible: visible,
      imageUrl: imageUrl,
      toolbarVisible: false,
      warningModalVisible: false
    })
  }

  closeFullScreen = () => {
    this.props.dispatch({
      type: 'UI_DIALOG',
      label: 'PHOTO_FULL_SCREEN',
      value: {
        imageUrl: "",
        imageDBPath: ""
      }
    })
  }

  photoActions(action){
    switch(action){
      case SHOW_WARNING:
        this.setState({warningModalVisible: true});
        break;
      case CLOSE_WARNING:
        this.setState({warningModalVisible: false});
        break;
      case DELETE_IMAGE: {
        const path = `${this.props.imageDBPath}/delete`
        const update = {}
        update[path] = true;
        firebase.database().ref().update(update);
        this.closeFullScreen();
        break;
      }
    }
  }

  render() {
    const deleteWarningActions = [
      <FlatButton
        key='cancel'
        label="Cancel"
        primary={true}
        onClick={this.photoActions.bind(this, CLOSE_WARNING)} />,
      <FlatButton
        key='delete'
        label="Delete"
        disableTouchRipple={false}
        primary={true}
        backgroundColor={red500}
        labelStyle={{color: 'white'}}
        hoverColor={red800}
        onClick={this.photoActions.bind(this, DELETE_IMAGE)} />
    ];

    const topToolbar = (
      <Transition in={this.state.toolbarVisible} timeout={400}>
        {
          (state) => {
            return(
              <div
                key={'topToolbar'}
                style={Object.assign({}, {
                  transition: `opacity 400ms ease-in-out`,
                  opacity: 0,
                  top: 0,
                  backgroundColor: 'rgba(0,0,0,0.5)',
                  position: 'absolute',
                  width: 600,
                  display: 'flex',
                  justifyContent: 'flex-end'
                }, this.transitionStyles[state])}>
                <FlatButton
                  style={{ height: 60 }}
                  onTouchTap={this.closeFullScreen}>
                  <CloseIcon color={'white'} style={{width: 32, height: 32}}/>
                </FlatButton>
              </div>
            )
          }
        }
      </Transition>
    )

    const bottomToolbar = (
    // By the time, there is only one action in the bottom toolbar,
    // adding a download option would required to modify the implementation
    // to show only actions required by the calling component.
      !this.props.disableDeletion &&
      <Transition in={this.state.toolbarVisible} timeout={400}>
        {
          (state) => <div
            key={'bottomToolbar'}
            style={Object.assign({}, {
              transition: `opacity 400ms ease-in-out`,
              opacity: 0,
              bottom: 0,
              backgroundColor: 'rgba(0,0,0,0.5)',
              position: 'absolute',
              width: 600,
              display: 'flex',
              justifyContent: 'flex-end'
            }, this.transitionStyles[state])}>

            {
              //TODO: make download functionality
              // <FlatButton
              //   style={{ height: 60 }}
              //   onTouchTap={() => {
              //
              //   }}>
              //   <DownloadIcon color={'white'} style={{ width: 32, height: 32}}/>
              // </FlatButton>
              <FlatButton
                style={{ height: 60 }}
                onTouchTap={this.photoActions.bind(this, SHOW_WARNING)}>
                <DeleteIcon color={'white'} style={{width: 32, height: 32}}/>
              </FlatButton>
            }
          </div>
        }
      </Transition>
    )

    return (
      <Dialog
        open={this.state.fullscreenVisible}
        bodyStyle={{
          padding: 0
        }}
        contentStyle={{
          display:'flex',
          justifyContent: 'center',
          alignSelf: 'center',
          padding: 0,
        }}
        autoScrollBodyContent={true}
        onRequestClose={this.closeFullScreen}>

        <div
          style={{
            width: 600,
            height: 400,
            flexDirection: 'column',
            display: 'flex',
            justifyContent: 'center',
            backgroundColor: 'white'
          }}
          onMouseEnter={() => {
            this.setState({toolbarVisible: true})
          }}
          onMouseLeave={() => {
            this.setState({toolbarVisible: false})
          }}>

          {topToolbar}

          <div
            style={{
              display: 'block',
              flexDirection:'row',
              alignSelf: 'center',
              justifyContent: 'center',
            }}>
            <img
              style={{
                display: 'block',
                width: 'auto',
                maxWidth: 600,
                maxHeight: 400,
              }}
              src={this.state.imageUrl}/>
          </div>

          {bottomToolbar}

        </div>

        <Dialog
          open={this.state.warningModalVisible}
          actions={deleteWarningActions}
          contentStyle={{
            display:'flex',
            justifyContent: 'center',
            alignSelf: 'center',
            padding: 0,
          }}
          onRequestClose={this.photoActions.bind(this, CLOSE_WARNING)}>
          <div>This photo will not be available any longer after deletion.</div>
        </Dialog>

      </Dialog>
    )
  }

}

function mapStateToProps(state){
  const args = state.uiDialogs['PHOTO_FULL_SCREEN'];
  if (args){
    return args;
  } else {
    return {}
  }
}

export default connect(mapStateToProps)(PhotoScreen);



// WEBPACK FOOTER //
// ./src/common/PhotoScreen.js